import { render } from "./VirtualTicket.vue?vue&type=template&id=ba74e3c8"
import script from "./VirtualTicket.vue?vue&type=script&lang=js"
export * from "./VirtualTicket.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vote.gikit.ru/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__